export const smallButton = {
                                  maxHeight: "25px",
                                  maxWidth: "55px",
                                  minWidth: "5px",
                                  marginBottom: "2px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                }